import { ComponentMap } from '@cinch-nx/data-storyblok'
import { StatsSection } from '@cinch-nx/landing-ui-shared'

import { ContentWithIcon, HelpMeChoose, Intro, Prefooter } from '../components'

export const storyblokComponents: ComponentMap = {
  GenericContentWithImageSection: Intro,
  ContentWithIconSection: ContentWithIcon,
  HelpMeChooseCTASection: HelpMeChoose,
  PrefooterCTA: Prefooter,
  StatsSection: StatsSection,
}
